'use strict';

var app = new Vue({
    el: '#juridisk-app',
    data: {
        // Member access
        isMember: window.TechnicalFormConfig ? window.TechnicalFormConfig.isMember : false,
        loginUrl: window.TechnicalFormConfig ? window.TechnicalFormConfig.loginUrl : '/Account/Login',
        registerUrl: window.TechnicalFormConfig ? window.TechnicalFormConfig.registerUrl : '/bli-medlem',

        currentStep: 1,
        loading: false,
        errors: {},

        // Contact info
        memberNumber: '',
        name: '',
        address: '',
        zipCode: '',
        city: '',
        phone: '',
        email: '',

        // The case
        caseDescription: '',

        // Other comments
        otherComments: '',

        // File uploads - stored locally until form submission
        localFiles: []
    },
    methods: {
        validateForm: function validateForm() {
            this.errors = {};

            // Contact info validation
            if (!this.memberNumber) this.errors.memberNumber = 'Du må fylle ut medlemsnummer';
            if (!this.name) this.errors.name = 'Du må fylle ut navn';
            if (!this.address) this.errors.address = 'Du må fylle ut adresse';
            if (!this.zipCode) this.errors.zipCode = 'Du må fylle ut postnummer';
            if (!this.city) this.errors.city = 'Du må fylle ut poststed';
            if (!this.phone) this.errors.phone = 'Du må fylle ut telefonnummer';
            if (!this.email) this.errors.email = 'Du må fylle ut e-postadresse';

            if (this.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
                this.errors.email = 'Ugyldig e-postadresse';
            }

            // Case description always required
            if (!this.caseDescription) this.errors.caseDescription = 'Du må fylle ut en kort forklaring av saken';

            return Object.keys(this.errors).length === 0;
        },
        handleFileUpload: function handleFileUpload(event, fileType) {
            var files = event.target.files;
            if (!files || files.length === 0) return;

            var MAX_TOTAL_SIZE_BYTES = 52428800;
            var currentTotal = this.localFiles.reduce(function (sum, f) {
                return sum + f.file.size;
            }, 0);
            var incoming = 0;
            for (var j = 0; j < files.length; j++) {
                incoming += files[j].size;
            }
            if (currentTotal + incoming > MAX_TOTAL_SIZE_BYTES) {
                alert('Filene er for store. Maks totalstørrelse er 50 MB.');
                event.target.value = '';
                return;
            }

            // Store files locally - will be uploaded on form submission
            for (var i = 0; i < files.length; i++) {
                this.localFiles.push({
                    file: files[i],
                    name: files[i].name,
                    type: fileType
                });
            }

            event.target.value = '';
        },
        removeFile: function removeFile(file) {
            var index = this.localFiles.indexOf(file);
            if (index > -1) {
                this.localFiles.splice(index, 1);
            }
        },
        submitForm: function submitForm() {
            var self = this;
            if (!this.validateForm()) {
                var firstError = document.querySelector('.text-danger');
                if (firstError) {
                    firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                return;
            }

            this.loading = true;

            // Build FormData for multipart submission
            var formData = new FormData();

            formData.append('memberNumber', this.memberNumber);
            formData.append('name', this.name);
            formData.append('address', this.address);
            formData.append('zipCode', this.zipCode);
            formData.append('city', this.city);
            formData.append('phone', this.phone);
            formData.append('email', this.email);
            formData.append('caseDescription', this.caseDescription);
            formData.append('otherComments', this.otherComments || '');

            // Add files with type-prefixed names
            this.localFiles.forEach(function (fileObj) {
                formData.append('files-' + fileObj.type, fileObj.file, fileObj.name);
            });

            axios.post('/teknisk/juridisk-bistand', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            }).then(function () {
                window.location.href = '/teknisk/skjema/takk?skjema=' + encodeURIComponent(window.location.pathname);
            }).catch(function (error) {
                alert('En feil oppstod ved innsending av skjemaet. Vennligst prøv igjen.');
                self.loading = false;
            });
        }
    }
});